import { APP_NAME } from 'app-config'

import { TimeInterval } from 'root-constants'

export function createProductId({
  periodName,
  periodQuantity,
  price,
}: {
  periodName: TimeInterval | null
  periodQuantity: number | null
  price: number
}): string {
  return `${APP_NAME}_${periodQuantity}_${periodName}_${price}`
}
